import type { FaireProductEntity } from "../../entity_types/product";

export const p_yrej9n93jz: FaireProductEntity = {
  token: "p_yrej9n93jz",
  type: "product",
  name: "Paleo Vegan Pistachio Bars - Pack of 3",
  brandToken: "b_7qrub4tp9v",
  brandName: "Konscious Kitchen Inc",
  imageUrl: "https://cdn.faire.com/fastly/fcbc65c0fda8fa1472b5b9706936f3861c85e1ab008e49dc1818ba1daaa27f24.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/089862cb40e342612d4ef3c2ee4dfebb0c38647abe459aed5c64864edf9384ee.jpeg",
    "https://cdn.faire.com/fastly/8eb747e0dcb908322ebb76b481374890b589086b75f27f1e879d64eba867e5be.png",
    "https://cdn.faire.com/fastly/b2c3e252c07a5e8987681b96a4b9769855d4e83e395b23f07f570874202c817d.png"
  ],
  priceDollars: 8.99,
  description: "Soft almond middle filled with pistachios and sweetened with maple syrup with a crunchy bottom and a chocolaty top – a bite into each layer is an experience in itself.\n\nKey Features:\nGluten Free\nPaleo\nGrain Free\nDairy Free\n\nIngredients:\nOrganic Coconut Flour, Organic Coconut Oil, Organic Maple Syrup, Himalayan Pink Salt, Almond Butter, Pure Vanilla Extract, Pistachios, Semi Sweet Chocolate (Cocoa Mass, Cocoa Butter, Brown Sugar)\n",
  tags: [],
  msrpDollars: 13.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:54.154Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
